import reduce from "lodash/reduce";
import { ROOT_COLUMN_KEY } from "PFApp/booking/parts/overview/booking_module_calendar/booking_calendar/calendar_content/dual_scrollable_grid/constants";
import { useProfileCustomValues } from "PFApp/hooks/use_profile_custom_values";
import { TableColumn } from "PFCore/types";
import { useTranslation } from "react-i18next";

const PROFILE_FIELDS_SECTION_KEYS = [
  "match_info_1",
  "match_info_2",
  "match_info_3",
  "match_info_4",
  "match_info_5",
  "current_experience_title_1"
];

type UseProfilesColumnsReturn = {
  availableColumns: TableColumn[];
};

export const useProfilesColumns = (): UseProfilesColumnsReturn => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "rowsSidePanel.columns" });
  const { getCustomType } = useProfileCustomValues();

  const availableColumns: TableColumn[] = reduce(
    PROFILE_FIELDS_SECTION_KEYS,
    (acc: TableColumn[], sectionKey) => {
      const customType = getCustomType(sectionKey);
      if (!customType) {
        return acc;
      }
      const existingCustomType = acc.find(({ orderKey }) => orderKey === `custom_fields.${customType.name}`);
      if (existingCustomType) {
        existingCustomType.attribute?.push(sectionKey);
      } else {
        acc.push({
          name: sectionKey,
          title: customType.display_as ?? "",
          type: "custom_field",
          orderKey: `custom_fields.${customType.name}`,
          attribute: [sectionKey] // HACK: in case custom field has multiple sections we store them as `attribute`
        });
      }
      return acc;
    },
    [
      {
        name: ROOT_COLUMN_KEY,
        title: t("workforceMember"),
        isDefault: true,
        locked: true,
        fixedPosition: true
      }
    ]
  );

  return { availableColumns };
};
